module.exports = __webpack_public_path__ + "static/media/wallet.815b30b5.svg";